import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AlbumImage } from '../../models/image.album.model';
import {
  albumImageAdapter,
  AlbumImageState,
} from '../reducers/image.album.reducer';

export const getAlbumImageState =
  createFeatureSelector<AlbumImageState>('albumImages');
export const getIds = (state: AlbumImageState) => state.ids;

export const {
  selectIds: getAlbumImageIds,
  selectEntities: getAlbumImageEntities,
  selectAll: getAllAlbumImages,
  selectTotal: getTotalAlbumImages,
} = albumImageAdapter.getSelectors(getAlbumImageState);

export const loading = createSelector(
  getAlbumImageState,
  (state: AlbumImageState) => state.loading,
);

export const inProgress = createSelector(
  getAlbumImageState,
  (state: AlbumImageState) => state.inProgress,
);

export const getAlbumImagesByAlbumId = (albumId?: string) =>
  createSelector(getAllAlbumImages, (albumImages) =>
    albumImages
      .filter((albumImage) => albumImage.albumId === albumId)
      .sort(sortDescendingByDate),
  );

export const getAlbumImageById = (albumImageId?: string) =>
  createSelector(getAllAlbumImages, (albumImages) =>
    albumImages.find((albumImage) => albumImage.id === albumImageId),
  );

function sortDescendingByDate(a: AlbumImage, b: AlbumImage): number {
  return a.created > b.created ? -1 : a.created < b.created ? 1 : 0;
}
